// extracted by mini-css-extract-plugin
export default {"socialMedias":"SocialMedias_socialMedias__rkACy"};